import React, { useEffect, useRef } from 'react'
import { InputText } from 'primereact/inputtext'
import './inputComp.scss'

const InputTextComp = (
  inputProps,
  { name, value, onChange, autoFocus = false },
) => {
  const ref = useRef(null)
  useEffect(() => {
    if (autoFocus) ref?.current?.focus()
  }, [])

  return (
    <InputText
      ref={ref}
      name={name}
      value={value}
      onChange={onChange}
      {...inputProps}
    />
  )
}

export default InputTextComp
